module.exports = __webpack_public_path__ + "static/media/pt.7b888af4.svg";